module.exports = "/_next/static/videos/hockey-1-ed407ca71abe45f2aa5b73cec474ae64.webm";